<script setup lang="ts">
import { Toaster as Sonner } from 'vue-sonner'
import { reloadNuxtApp } from '#imports'

const { loggedIn, company } = storeToRefs(useAuthStore())

const title = ref('Supercharge your revenue and customer growth')
const description = ref(
  'Bunce is a payment automation tool that helps businesses grow their revenue and customers with integrations to all payment processors and accounting software in Africa.',
)

// Trigger rerendering the page when account changes
const key = computed(() => `${company.value?.id || ''}`)
const id = useId()

useHead({
  title,
  htmlAttrs: {
    lang: 'en',
  },
  titleTemplate: (title: any) =>
    title !== title.value
      ? `${
          title > 50
            ? `${title.slice(0, 50)}...${title.endsWith('"') ? '"' : ''}`
            : title
        } · Bunce`
      : title,
  link: [
    {
      rel: 'icon',
      type: 'image/png',
      href: '/thumbnail.png',
    },
  ],
})

useSeoMeta({
  title,
  ogTitle: title,
  ogType: 'website',
  ogUrl: 'https://app.bunce.so',
  description: () => description.value,
  ogDescription: description.value,
  ogImage: '/thumbnail.png',
  twitterCard: 'summary_large_image',
  twitterSite: '@trybunce',
  twitterImage: '/thumbnail.png',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
})

useGetCountryListQuery()

if (loggedIn.value) {
  const { isLoading } = useProfileQuery({
    onError: () => useRouter().push({ name: 'index' }),
  })

  useState('loading', () => isLoading)

  getPersonalizationTagsQuery()
}

watch(
  () => useState('environment'),
  () => reloadNuxtApp({ force: true, persistState: true }),
  {
    deep: true,
  },
)
</script>

<template>
  <div>
    <Sonner
      theme="light"
      class="toaster group"
      position="top-right"
      :class-names="{
        toast:
          'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-muted-foreground',
        actionButton:
          'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
        cancelButton:
          'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
      }"
      :duration="4000"
      rich-colors
      :close-button="true"
    />
    <NuxtLayout :key="key">
      <NuxtLoadingIndicator
        color="repeating-linear-gradient(to right,#E7F0FE 0%, #3143B5 100%)"
      />
      <div>
        <NuxtPage />
      </div>
    </NuxtLayout>
  </div>
</template>
